module.exports = __webpack_public_path__ + "static/media/Tomas.f8df1d4f.png";